import { Directive, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Directive({
    selector: '[appLoadScript]',
    standalone: false
})
export class LoadScriptDirective implements OnInit {

    @Input() script: any;
    @Output() loadingCompleted: EventEmitter<any> = new EventEmitter();

    ngOnInit() {
        const node = document.createElement('script');
        node.src = this.script;
        node.type = 'text/javascript';
        node.async = false;

        node.onload = () => {
            this.loadingCompleted.emit();
        };

        let found = false;
        document.getElementsByTagName('head')[0].childNodes.forEach(x => {
            if (x.isEqualNode(node)) {
                found = true;
            }
        });

        if (!found) {
            document.getElementsByTagName('head')[0].appendChild(node);
        } else {
            setTimeout(() => this.loadingCompleted.emit(), 500);
        }
    }
}
